const RE_REF = /\[([^\]]+)]/g;

export default RE_REF;
